import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  const [typeEffect] = useTypewriter({
    words: [
      "Full stack Developer 💻",
      "Anguler Developer 🌐",
      "React Developer 🌐",
      "SQLServer,EF Dev 🔥",
      "ASP.NET Web API Dev🌐",
      "ASP.NET Web MVC Dev💥",
      "Windows App Dev⚡",
    ],
    loop: {},
    typeSpeed: 100,
    deleteSpeed: 60,
  });
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://www.facebook.com/peter.mmdoh">
                <i className="fa fa-facebook-square" />
              </a>
              <a href="https://github.com/peterM65?tab=repositories">
                <i className="fa fa-github" />
              </a>
              <a href="https://www.linkedin.com/in/peter-mamdouh-fullstack/">
                <i className="fa fa-linkedin-square" />
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'M <span className="highlighted-text"style={{ fontWeight: "bold", color: "red" }} >Peter</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {""}
              <h1 style={{ fontWeight: "bold", color: "red" }}>
                I'm a
                <span
                  style={{
                    fontWeight: "bold",
                    color: "green",
                    marginLeft: "5px",
                  }}
                >
                  {typeEffect}
                </span>
              </h1>
              <br />
              <span className="profile-role-tagline">
                Knack of building applications with front and back end
                operations.
              </span>
            </span>
          </div>
          <br />
          <div className="profile-options">
            <button className="btn primary-btn"
            onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {""}
              Hire Me{" "}
            </button>
            <a href="PeterMamdouhYoussef.pdf" download={"Peter Mamdouh CV.pdf"}>
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
